module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zm7.702 15.074l-6.958 6.644a1.053 1.053 0 0 1-1.434 0L8.294 15.02a.94.94 0 0 1 0-1.368l1.434-1.368a1.046 1.046 0 0 1 1.432 0l4.868 4.644 4.81-4.59a1.043 1.043 0 0 1 1.43 0l1.434 1.368a.933.933 0 0 1 0 1.368z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/down-circle-2.js
// module id = 1111
// module chunks = 14